export const ADD_TO_CART_REQUEST = "ADD_TO_CART_REQUEST";
export const ADD_TO_CART_SUCCESS = "ADD_TO_CART_SUCCESS";
export const ADD_TO_CART_ERROR = "ADD_TO_CART_ERROR";

export const FETCH_CART_REQUEST = "FETCH_CART_REQUEST";
export const FETCH_CART_SUCCESS = "FETCH_CART_SUCCESS";
export const FETCH_CART_ERROR = "FETCH_CART_ERROR";

export const REMOVE_CART_ITEM_REQUEST = "REMOVE_CART_ITEM_REQUEST";
export const REMOVE_CART_ITEM_SUCCESS = "REMOVE_CART_ITEM_SUCCESS";
export const REMOVE_CART_ITEM_ERROR = "REMOVE_CART_ITEM_ERROR";

export const REMOVE_ALL_CART_ITEM_REQUEST = "REMOVE_ALL_CART_ITEM_REQUEST";
export const REMOVE_ALL_CART_ITEM_SUCCESS = "REMOVE_ALL_CART_ITEM_SUCCESS";
export const REMOVE_ALL_CART_ITEM_ERROR = "REMOVE_ALL_CART_ITEM_ERROR";

export const FETCH_TOTAL_CART_ITEMS_REQUEST = "FETCH_TOTAL_CART_ITEMS_REQUEST";
export const FETCH_TOTAL_CART_ITEMS_SUCCESS = "FETCH_TOTAL_CART_ITEMS_SUCCESS";
export const FETCH_TOTAL_CART_ITEMS_ERROR = "FETCH_TOTAL_CART_ITEMS_ERROR";

export const FETCH_CART_NO_FEE_REQUEST = "FETCH_CART_NO_FEE_REQUEST";
export const FETCH_CART_NO_FEE_SUCCESS = "FETCH_CART_NO_FEE_SUCCESS";
export const FETCH_CART_NO_FEE_ERROR = "FETCH_CART_NO_FEE_ERROR";
